import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Layout, Menu, message } from "antd";
import {
  MdAutoMode,
  MdDashboard,
  MdHighQuality,
  MdOutlineSupervisedUserCircle,
} from "react-icons/md";
import { logout } from "../Views/Auth/Login/AuthapiFunctions";
import {
  AreaChartOutlined,
  ContactsOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProductOutlined,
  PropertySafetyFilled,
} from "@ant-design/icons";
import { TbCategoryPlus } from "react-icons/tb";
import { VscRequestChanges, VscSymbolProperty } from "react-icons/vsc";
import { GrServices } from "react-icons/gr";
import { AiOutlinePropertySafety } from "react-icons/ai";
import { BsBag, BsJournalBookmark } from "react-icons/bs";
import { PiFlagBannerFill, PiOfficeChairLight } from "react-icons/pi";
import { HiOfficeBuilding } from "react-icons/hi";
import SubMenu from "antd/es/menu/SubMenu";
import { FcAutomatic, FcAutomotive } from "react-icons/fc";
import { LiaStackExchange } from "react-icons/lia";
import { Header } from "antd/es/layout/layout";
import { images } from "../assets/images";
const { Sider, Content } = Layout;
const BasicLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      window.innerWidth <= 600 ? setCollapsed(true) : setCollapsed(false);
    };
    window.addEventListener("resize", handleResize);
    const stored = localStorage.getItem("selected");
    if (stored) {
      setSelectedMenu(stored);
    }
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    localStorage.setItem("selected", selectedMenu);
  }, [selectedMenu]);

  function getlogout() {
    localStorage.clear();
    navigate("/");
    message.success("Admin Logged Out Successfully");
  }

  const menuItems = [
    {
      key: "1",
      icon: <MdDashboard />,
      label: "Dashboard",
      onClick: () => {
        setSelectedMenu("1");
        navigate("/dashboard");
      },
    },
    {
      key: "2",
      icon: <MdOutlineSupervisedUserCircle />,
      label: "Users",
      onClick: () => {
        setSelectedMenu("2");
        navigate("/vendorsDetails");
      },
    },
    {
      key: "3",
      icon: <TbCategoryPlus />,
      label: "Categories",
      onClick: () => {
        setSelectedMenu("3");
        navigate("/categoryDetails");
      },
    },
    // {
    //   key: "9",
    //   icon: <PiFlagBannerFill />,
    //   label: "Banners",
    //   onClick: () => {
    //     setSelectedMenu("9");
    //     navigate("/bannerDetails");
    //   },
    // },
    // {
    //   key: "10",
    //   icon: <AreaChartOutlined />,
    //   label: "State",
    //   onClick: () => {
    //     setSelectedMenu("10");
    //     navigate("/stateDetails");
    //   },
    // },
    // {
    //   key: "4",
    //   icon: <VscRequestChanges />,
    //   label: "Requests for Vendors",
    //   onClick: () => {
    //     setSelectedMenu("4");
    //     navigate("/userRequests");
    //   },
    // },
    {
      key: "5",
      icon: <VscSymbolProperty />,
      label: "News And Blogs",
      subMenuItems: [
        {
          key: "5-1",
          label: "Blog Category",
          onClick: () => {
            setSelectedMenu("5-1");
            navigate("/blog/blogCategory");
          },
        },

        {
          key: "5-2",
          label: "Blog Data",
          onClick: () => {
            setSelectedMenu("5-2");
            navigate("/blog/blogData");
          },
        },
        // {
        //   key: "5-3",
        //   label: "Plot Details",
        //   onClick: () => {
        //     setSelectedMenu("5-3");
        //     navigate("/plotDetails");
        //   },
        // },
      ],
    },
    {
      key: "6",
      icon: <VscSymbolProperty />,
      label: "Properties",
      subMenuItems: [
        {
          key: "6-1",
          label: "Amenities Details",
          onClick: () => {
            setSelectedMenu("6-1");
            navigate("/amenitiesDetails");
          },
        },
        {
          key: "6-2",
          label: "Property Details",
          onClick: () => {
            setSelectedMenu("6-2");
            navigate("/propertiesDetails");
          },
        },
        {
          key: "6-3",
          label: "Property Status",
          onClick: () => {
            setSelectedMenu("6-3");
            navigate("/propertyTypeDetails");
          },
        },
      ],
    },
    {
      key: "7",
      icon: <VscRequestChanges />,
      label: "Enquiry Details",
      onClick: () => {
        setSelectedMenu("7");
        navigate("/enquiryDetails");
      },
    },
    {
      key: "8",
      icon: <ContactsOutlined />,
      label: "Contact Details",
      onClick: () => {
        setSelectedMenu("8");
        navigate("/contactDetails");
      },
    },
    {
      key: "9",
      icon: <ContactsOutlined />,
      label: "Subscription Details",
      onClick: () => {
        setSelectedMenu("9");
        navigate("/subscriptionDetails");
      },
    },
  ];

  return (
    <Layout className="min-h-screen sidebar bg-rgbaprimary1">
      <Layout>
        <Sider
          className={`${collapsed ? "collapsedsidebar" : "sidebar"}`}
          collapsible
          width={250}
          collapsed={collapsed}
          onCollapse={() => setCollapsed(!collapsed)}
        >
          <div className="flex justify-center mb-4">
            {!collapsed ? (
              <img
                src={images.icon}
                alt="logo"
                className=" mt-9  w-56  rounded-2xl "
              />
            ) : (
              <img
                src={images.icon}
                alt="logo"
                className="px-2 mt-9"
                width={"80px"}
                height={"70px"}
              />
            )}
          </div>

          {/* <div className="demo-logo-vertical d-flex justify-content-center m-2 ">
            {!collapsed ? (
              <div className="font-poppins text-5xl font-bold text-rgbaprimary2 flex justify-center items-center m-9">
                Ezulix
              </div>
            ) : (
              <div className="font-poppins text-xs font-bold text-rgbaprimary2 flex justify-center items-center m-9">
                Ezulix
              </div>
            )}
          </div> */}
          <Menu
            mode="inline"
            className="text-base pb-24 font-inter "
            selectedKeys={[selectedMenu]}
          >
            {menuItems.map((item) =>
              item.subMenuItems ? (
                <Menu.SubMenu
                  key={item.key}
                  icon={item.icon}
                  title={item.label}
                >
                  {item.subMenuItems.map((subItem) => (
                    <Menu.Item key={subItem.key} onClick={subItem.onClick}>
                      {subItem.label}
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              ) : (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  onClick={item.onClick}
                >
                  {item.label}
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout className="bg-rgbaprimary1">
          <Header
            style={{
              padding: 0,
              backgroundColor: "white",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />

            <Button
              onClick={getlogout}
              className="bg-rgbaprimary9 border-none outline-none text-xs text-white cursor-pointer px-2 py-2 m-3 w-24 text-center rounded-md hover:bg-bssecondary"
            >
              Log Out{" "}
            </Button>
          </Header>
          <Content
            className="min-h-screen bg-rgbaprimary1  p-4 shadow-[-5px_0px_15px_#ddd]"
            style={{
              margin: 0,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default BasicLayout;
